import { Component, Input, Output, EventEmitter, OnInit, OnChanges, ViewChild } from '@angular/core';
import { ModalController } from 'ionic-angular';
import { CountryCodeComponent } from './country-code/country-code.component';
import { parse, CountryPhoneCodeDetails, isValidNumber } from '../../../../../UI/src/app/shared/phone-numbers/phone-number.service';

@Component({
  selector: 'sts-phone-input',
  templateUrl: './phone-input.component.html'
})
export class PhoneInputComponent implements OnInit, OnChanges {
  @Output() userPhoneNumber: EventEmitter<any> = new EventEmitter(true);
  @Input() inputPhoneNumber: number;
  @Input() labelId;
  @Input() required = false;
  @Input() isEdit: boolean = false;
  @ViewChild('mobileNumber') mobileNumber: any;
  public countryCode = {
    phoneCode: '1',
    alpha2Code: 'US'
  };
  countryPhoneCodes: any[];
  constructor(
    public modalCtrl: ModalController,
    private countryPhoneCodeDetails: CountryPhoneCodeDetails,
  ) {
    this.countryPhoneCodes = this.countryPhoneCodeDetails.countryPhoneCodes;
  }

  ngOnInit() {

  }

  ngOnChanges() {
    if (this.inputPhoneNumber) {
      const parsedNumber = parse(this.inputPhoneNumber);
      if (parsedNumber.country && parsedNumber.phone) {
        this.inputPhoneNumber = parsedNumber.phone;
        const selCountry = this.countryPhoneCodes.filter(country => country.alpha2Code === parsedNumber.country);
        if (selCountry && selCountry.length > 0) {
          this.countryCode = selCountry[0];
        }
        this.formatPhoneNumber();
      } else {
        this.userPhoneNumber.emit(true); // invalid mobile number
      }
    } else {
      this.userPhoneNumber.emit(null); // empty mobile number
    }
  }

  formatPhoneNumber() {
    if (isValidNumber(this.inputPhoneNumber, this.countryCode.alpha2Code)) {
      this.userPhoneNumber.emit('+' + this.countryCode.phoneCode + this.inputPhoneNumber);
    } else if (this.isEdit) {
      this.userPhoneNumber.emit(true);
    } else  {
      this.userPhoneNumber.emit(null);
    }
  }

  selectCountryCode() {
    let modal = this.modalCtrl.create(CountryCodeComponent);
    modal.onDidDismiss(data => {
      this.countryCode = data;
      let elm = this.mobileNumber._elementRef.nativeElement.querySelector('input');
      if (elm)
        elm.focus();
    });
    modal.present();
  }
}



// WEBPACK FOOTER //
// ./src/app/lib/phone-input/phone-input.component.ts